export default __webpack_public_path__ + "static/media/leaf1.80681761.png";